module.exports = __webpack_public_path__ + "img/icon-code.e64cfa43.svg";